import { CertificateDocumentTypeV2 } from '../../enums/CertificateDocumentType'

export const CertificateGroup = {
  Certificate: 'certificate_',
  PartyType: 'partytype_',
  Questions: 'questions_',
  Recommendation: 'recommendation_',
  Certify: 'certify_',
}

export enum CertificateGroupEnum {
  Certificate = 1,
  PartyType = 2,
  Questions = 3,
  Recommendation = 4,
  Certify = 5,
}

export const getCertificateGroupPrefix = (group: CertificateGroupEnum): string => {
  switch (group) {
    case CertificateGroupEnum.Certificate:
      return CertificateGroup.Certificate
    case CertificateGroupEnum.PartyType:
      return CertificateGroup.PartyType
    case CertificateGroupEnum.Questions:
      return CertificateGroup.Questions
    case CertificateGroupEnum.Recommendation:
      return CertificateGroup.Recommendation
    case CertificateGroupEnum.Certify:
      return CertificateGroup.Certify
    default:
      return ''
  }
}

export const getAttributeUniqueName = (groupName: CertificateGroupEnum, attributename: string) => {
  return `${getCertificateGroupPrefix(groupName)}${attributename}`
}

export const trfUploadAllowedScheme = ['IECEE CB Scheme']

export const CNGSchemeWithIssuingBody = [
  'IECEE CB Scheme',
  'IECEE CB Scheme Component',
  'IECEE CB Scheme Aspect',
]

export const CNGSchemeName = [
  { name: 'IECEE CB Scheme', value: 'IECEE CB Scheme' },
  { name: 'IECEE CB Scheme Component', value: 'IECEE CB Scheme' },
  { name: 'IECEE CB Scheme Aspect', value: 'IECEE CB Scheme' },
  { name: 'ANATEL MARK', value: 'Inmetro, Anatel, UL BR Mark' },
  { name: 'INMETRO Scheme', value: 'Inmetro, Anatel, UL BR Mark' },
  { name: 'INMETRO HazLoc Scheme', value: 'Inmetro, Anatel, UL BR Mark' },
  { name: 'UL-BR Mark Scheme', value: 'Inmetro, Anatel, UL BR Mark' },
]

export const CERTIFICATE_DOCUMENT_TYPE_ALLOWED_LINK = [
  CertificateDocumentTypeV2.Certificate,
  CertificateDocumentTypeV2.TestReport,
]

export const CERTIFICATE_GROUPS = {
  PARTY_TYPE: 'B_PARTY TYPE',
  QUESTION_TYPE: 'C_QUESTIONS',
  CERTIFICATE_TYPE: 'A_CERTIFICATE',
  RECOMMENDATION_TYPE: 'D_RECOMMENDATION',
  CERTIFY_TYPE: 'E_CERTIFY',
  PRODUCTS_EVAL: 'Products & Evaluations',
  PRODUCTS_EVAL_TEXT: 'Products & Evaluations',
  LEVEL_ID: 'custom_products_eval',
}

export const CERTIFICATE_SCHEME = {
  ANZ_CERTIFICATION_SCHEME: 'ANZ Certification Scheme',
}

export const DOCUMENT_TYPE_LIST = [
  CertificateDocumentTypeV2.Certificate,
  CertificateDocumentTypeV2.TestReport,
  CertificateDocumentTypeV2.R2CPackage,
  CertificateDocumentTypeV2.InspectionSurveillance,
  CertificateDocumentTypeV2.InternalFiles,
]

export const CERTIFICATE_DRAFT_FIELDS = [
  'certificate_issuingBody',
  'certificate_mark',
  'certificate_certificateName',
  'certificate_certificateType',
  'certificate_revisionNumber',
  'certificate_ownerReference',
]

export const CERTIFICATE_MARK_WITHOUT_IMAGE_COLUMNNS = ['nz coc', 'anz cos jas-anz', 'anz coa', '']

export const SUMMARY_MAX_LENGTH = 150
export const SUMMARY_MAX_LENGTH_MESSAGE = `Maximum input limit reached, value cannot exceed ${SUMMARY_MAX_LENGTH} characters.`

export const CERTIFICATE_SUMMARY_OF_MODIFICATIONS = 'certificate_summaryofModifications'
export const CERTIFICATE_OWNER_REFERENCE = 'certificate_ownerReference'

// DOCUMENT ACTION LABEL
export const UnlinkEcmBtnText = 'Unlink File from WB'
export const LinkToWbBtnText = 'Link File to WB'
export const displayUnlinkEcmModalHeader = 'Unlink File Confirmation'
